export enum LocaleDissectionRegexKeys {
  FullLocale = "FullLocale",
  Language = "Language",
  Market = "Market",
  Script = "Script",
  SitePath = "SitePath",
}

/**
 * Used to split a locale language into its language and script parts i.e. en-Latn to en and Latn, en to en
 * This value is used in our express-locale patch to replace their nonLocaleCharacters regex.
 */
export const localeLanguageAndScriptDissectionRegex = `(?<${LocaleDissectionRegexKeys.Language}>[a-z]{2,4})(?:-(?<${LocaleDissectionRegexKeys.Script}>[a-z]{4}))?`;

/**
 * Used to split a locale into its language and market parts i.e. en-Latn-us to en-Latn and us, en-us to en and us
 * This value is used in our express-locale patch to replace their regex that splits the language market.
 */
export const localeLanguageAndMarketDissectionRegex =
  /([a-z]{2,4}-[a-z]{4}|[a-z]{2,4})(?:-([a-z]{2}|[0-9]{3}))?/i;

/**
 * Regex pattern that matches any valid locale format as described by: https://learn.microsoft.com/en-us/openspecs/windows_protocols/ms-lcid/70feba9f-294e-491e-b6eb-56532684c37f
 * When referencing the result of this regex, please use the groups dictionary with the following keys (using /en-Latn-us/pdpPage as an example):
 *  - FullLocale i.e. en-Latn-us
 *  - Language i.e. en
 *  - Script i.e. Latn, this value represents the written script used to display the language (i.e. Latin or Cyrillic) and is not guaranteed to exist
 *  - Market i.e. us
 *  - SitePath i.e. /pdpPage
 */
export const localeUrlPrefixFullSupportRegex = new RegExp(
  // eslint-disable-next-line max-len
  `^/(?<${LocaleDissectionRegexKeys.FullLocale}>(?<${LocaleDissectionRegexKeys.Language}>[a-z]{2,4})-?(?<${LocaleDissectionRegexKeys.Script}>[a-z]{4})?-(?<${LocaleDissectionRegexKeys.Market}>[a-z]{2}|[0-9]{3}))(?<${LocaleDissectionRegexKeys.SitePath}>[/?].*)?$`,
  "i"
);

/**
 * Original regex replaced by localeUrlPrefixFullSupportRegex that finds a 2 segment locale and the path
 */
export const localeUrlPrefixRegex = /^\/([a-zA-Z]{2}-[a-zA-Z]{2})([/?].*)?$/;

/**
 * If a match is found with this regex, then the matched string is a valid locale.
 * This value is used in our express-locale patch to replace their languageOrLocale regex which confirms a string is properly formatted locale.
 */
export const localeValidationRegex = /^(([a-z]{2,4})-?([a-z]{4})?-([a-z]{2}|[0-9]{3}))$/i;

/**
 * Used to find any characters in a locale that are not valid.
 * This value is used in our express-locale patch to replace their nonLocaleCharacters regex.
 */
export const nonLocaleCharactersRegex = /[^a-z0-9]/gi;

export const normalizedRtlLanguages = ["AR", "HE"];
